import type { Cluster, ClusterCandidate } from '@/api/types'

// 결정 후보에 붙는 낱말. 클러스터 목록의 clusterStatus 와 같은 뜻을 같은 낱말로 말한다.

export function candidateWord(c: ClusterCandidate): string {
  if (c.state === 'founding') return '창설 중'
  if (c.state === 'draining' || c.state === 'maintenance') return '점검 중'
  if (!c.live) return '응답 없음'
  return '사용 가능'
}

/** 응답은 하지만 지금 참여할 수 없는 후보를 골랐을 때 보이는 한 문장. 보류·새로 만들기 선택은 별도다. */
export function unavailableWord(c: ClusterCandidate): string | null {
  switch (c.unavailable_reason) {
    case 'founding':
      return '창설 중'
    case 'not_active':
      return '지금은 참여할 수 없습니다.'
    default:
      return null
  }
}

/** 클러스터가 어떻게 등록됐는가. */
export function clusterOriginWord(origin: Cluster['origin']): string {
  switch (origin) {
    case 'founded':
      return '창설'
    case 'adopted':
      return '편입'
    case 'rediscovered':
      return '재등록'
  }
}

/** 임대 설정을 누가 정했는가. */
export function settingsSourceWord(source: Cluster['lease_settings_source']): string {
  return source === 'manual' ? '수동' : '자동'
}

/** 응답하는 멤버 수. */
export function liveText(c: Pick<Cluster, 'live_count' | 'member_count'>): string {
  return `응답 ${c.live_count}/${c.member_count}대`
}
